export const handleTopBtn = () => {
  window.scrollTo(0, 0);
};
